import { faRedo } from "@fortawesome/pro-regular-svg-icons";
import { faTimesCircle, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@vapor/react-extended/ExtendedTypography";
import Button from "@vapor/react-material/Button";
import Box from "@vapor/react-material/Box";
import Stack from "@vapor/react-material/Stack";
import { useNavigate } from "react-router-dom";

const ErrorAlert = () => {
    const navigate = useNavigate();

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            sx={{
                backgroundColor: "hsl(199, 15%, 95%)",
                minHeight: "calc(100vh - 48px)",
            }}
        >
            <Box sx={{ fontSize: "100px", position: "relative", marginBottom: "2rem" }}>
                <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    color="#c1c1c4"
                />
                <Box
                    sx={{
                        fontSize: "40px",
                        borderRadius: "100%",
                        position: "absolute",
                        bottom: "14px",
                        right: "-14px",
                        backgroundColor: "hsl(199, 15%, 95%)",
                        height: "50px",
                        width: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FontAwesomeIcon
                        icon={faTimesCircle}
                        color="#005175"
                    />
                </Box>
            </Box>
            <Typography
                variant="titleMedium"
                color="#005175"
                sx={{ marginBottom: "0.5rem" }}
            >
                Si è verificato un errore imprevisto
            </Typography>
            <Typography
                variant="body"
                color="#001924"
            >
                Stiamo risolvendo il problema. Riprova più tardi.
            </Typography>
            <Button
                onClick={() => navigate(0)}
                size="medium"
                startIcon={<FontAwesomeIcon icon={faRedo} />}
                variant="contained"
                sx={{ marginTop: "2.5rem" }}
            >
                Ricarica
            </Button>
        </Stack>
    );
};

export default ErrorAlert;
